export const environment = {
production: false,
host:"https://notifystaging.securenow.in",
apiUrl:"https://pamstaging.securenow.in",
msUrl:"https://pamstaging2.securenow.in",
pam2Url:"https://pamstaging2.securenow.in",
pam3Url:"https://pamstaging4.securenow.in",
pamUrl:"https://pamstaging4.securenow.in",
platformUrl:"https://uat-platform.securenow.in",
dpiRazorpayKey : "rzp_test_7oAe6WzF8NCEPe",
covidRazorpayKey : "rzp_test_7oAe6WzF8NCEPe",
pamLoginUrl: "https://pamstaging3.securenow.in",
targetUrl:"https://qawp.mfine.co/channel/securenow",
mfineSecretKey:"5GHD2CoGdLACISIeV0jM0kuGVoIcTWbh8OHr1QWCmEyh6LbdHvF6loaGQyyS3uUv",
mfinePlanId:"6225a9770a5cdddf3b7947e3",
mfineFreeGeneralPhysician:"659bf28ea69efc366d4eea6b",
mfineHost:"https://qa.api.mfine.co",
platform:"https://uat-platform.securenow.in",
freeGeneralUrl:"https://qawp.mfine.co/channel/securenow-gp",

medPayAuthUrl:"https://auth.uat.medpay.in",
medPayClientID:"589flo5k5obi4lupnugvqn27gi",
medPayclientSecret:"rujpnj2nbujh00o5v9c0iovu0cbcmmacatm2a2976o0m7orgb1m",
medPayAPIKey:"jIUnbJiwmr4ce7qrmAHdXsCOnxcwdBY6B6f324p3",
medPayHostUrl:"https://api.uat.medpay.in/v1",
mFineFreeSpecialists:"https://qawp.mfine.co/channel/securenowgnp",
mFineFreeSpecialistPlanId:"669f616d76cd90393183ffe2",

firebase : {
    apiKey: "AIzaSyCbUqdLre9aYHbtEi7q8VNBshJko8uhLl8",
    authDomain: "sn-app-pwa-6e66e.firebaseapp.com",
    projectId: "sn-app-pwa-6e66e",
    storageBucket: "sn-app-pwa-6e66e.firebasestorage.app",
    messagingSenderId: "988995119590",
    appId: "1:988995119590:web:e80c3d003ce122905a0e27",
    measurementId: "G-66CS85KMV2"
  },
  vapidKey: "BGmjdUXe_nZIw28BN603mJSHbvEQyqLe_9F_m0HPB02navz1aJF4LF97gwn3tOQDtZpMXvD8MBWPF6YcDtMbT24"
};